<template>
  <div class="zcxy">
    <div class="clearfix table-tools">
      <div class="buttons">
        <!-- <a-form layout='inline'>
          <a-form-item>
            <a-button icon="plus" type="primary" @click="showEditModal()">新增分类</a-button>
          </a-form-item>
        </a-form> -->
      </div>
      <div class="search">
        <a-form layout='inline' @submit="searchList">
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>订单编号</span>
              </template>
              <a-input allowClear v-model.trim="searchData.serial_number" placeholder="订单编号" style="width: 200px"/>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>手机号码</span>
              </template>
              <a-input allowClear v-model.trim="searchData.order_cellphone" placeholder="手机号码" style="width: 200px"/>
            </a-tooltip>
          </a-form-item>
          <a-form-item v-if="canIndex">
            <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="table">
      <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
      <a-table size="middle" :pagination="false" :bordered='false' rowKey="order_id"
        :columns="columns" :dataSource="list" :scroll="{ x: 1300 }">
          <template slot="index" slot-scope="text, record , index">
            <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
          </template>

        <template slot="orders" slot-scope="text, record">
          <div v-for="(item, index) of text" :key="index">{{ item.product_name }} x {{ item.product_count }}</div>
        </template>

        <template slot="serial_number" slot-scope="text, record">
          <a @click="showEditModal(record)">{{text}}</a>
        </template>

        <template slot="address" slot-scope="text, record">
          <span v-if="text">{{ text.province }}{{ text.city }}{{ text.district }}{{ text.address }}</span>
          <span v-else></span>
        </template>

          <template slot="action" slot-scope="text,record">
            <a v-if="canRead" href="javascript:;" @click="showEditModal(record)">详情</a>
            <!-- <a-divider v-if="canRead" type="vertical" />
            <a v-if="canDelete" href="javascript:;" @click="deleteItem(record)">删除</a> -->
          </template>
      </a-table>
    </div>
    <div class="page">
      <a-pagination
        :pageSizeOptions="pageSizeOptions"
        :total="pageParams.totalCount"
        showSizeChanger
        :pageSize="pageParams.perPage"
        v-model="current"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
      >
          <template slot='buildOptionText' slot-scope='props'>
            <span v-if="props.value!=='100'">{{props.value}}条/页</span>
            <span v-if="props.value==='100'">100条/页</span>
          </template>
        </a-pagination>
    </div>
    <editModal v-if="editVisible" :item="modalData"/>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'55px', scopedSlots: { customRender: 'index' }, key: 'index'},
  { title: '订单编号', width: '170px', dataIndex: 'serial_number', key: 'name',scopedSlots: { customRender: 'serial_number' }, },
  { title: '订单商品', dataIndex: 'orders', key: '1', scopedSlots: { customRender: 'orders' } },
  { title: '收货人姓名', dataIndex: 'address.user_name', key: '2' },
  { title: '手机号码', dataIndex: 'address.tel_number', key: '3' },
  { title: '收货地区', dataIndex: 'address', key: '4', scopedSlots: { customRender: 'address' } },
  { title: '总价', dataIndex: 'order_amount', width: 74, key: '5' },
  { title: '商品数量', dataIndex: 'product_count', width: 74, key: '6' },
  { title: '订单状态', dataIndex: 'status', width: 104, fixed: 'right', key: '7' },
  { title: '订单交易时间', dataIndex: 'created_at', width: 130, fixed: 'right', key: '8' },
  { title: '操作', key: 'operation', width: 60, fixed: 'right', scopedSlots: { customRender: 'action' }},
]

import C_ITEMS from '@/utils/items'
import editModal from './editModal'
import authority from '@/common/mixins/authority'
import tableMixins from '@/common/mixins/table'
export default {
  name: 'gjjl',
  provide() {
    return {
      parent: this
    }
  },

  components: {
    editModal,
  },

  data() {
    return {
      loading: false,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      columns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      current: 1,

      productStatus: C_ITEMS.productStatus,
      productCom: C_ITEMS.productCom,

      searchData: {},

      visible: false,
      modalData: {},
      editVisible: false,
      authType:['market','store'],
    }
  },
  mixins: [ authority, tableMixins ],

  methods: {
    closeSearch() {
      this.visible = false
    },
    async getList() {
      if(!this.canIndex){
          this.$message.warning('您暂无权限!!')
          return false
      }
      this.loading = true
      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          obj[k] = searchData[k]
        }
      }
      this.searchParams.search = obj
      let res = await this.$store.dispatch('storeOrderAction', { data: this.searchParams })
      this.list = res.items
      this.pageParams = res._meta
      this.loading = false
    },
    showEditModal(item) {
      this.modalData = item
      this.editVisible = true
    },
    hideEditModal(type) {
      if (type === 1) {
        this.getList()
      }
      this.editVisible = false
    },
    
    deleteItem(item) {
      let that = this
      this.$confirm({
        title: `您确定要删除"${item.cat_name}"吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('storeOrderDeleteAction', { data: { order_id: item.order_id } })
            if (res) {
              that.getList()
              resolve(res)
            }
          }).catch(error => console.log(error))
        }
      })
    },
  }
}
</script>
